// import AboutHeader from "./AboutHeader";
import SearchArea  from "./SearchArea";
import Breadcrumb from "./Breadcrumb";
import AboutOfferSection from "./AboutOfferSection";
import AboutUsSection from "./AboutUsSection";
import AboutCtaSection from "./AboutUsSection"; 
import AboutChefeSection from "./AboutChefeSection";
import AboutTestimonialSection from "./AboutTestimonialSection";
import BlogSection from "./BlogSection";

const About = () =>{
    return(
        <div>
            {/* <AboutHeader/> */}
            <Breadcrumb/>
            <SearchArea/>   
            {/* <AboutOfferSection/> */}
            { <AboutUsSection/> }
            {/* <AboutCtaSection/> */}
              <AboutTestimonialSection/>
            <AboutChefeSection/>
            {/* <BlogSection/> */}
            
        </div>
    )
}

export default About;   
